import { z } from 'zod';
import { EbpCaseSupportAuthorizationActionType } from '../../enums';
import { dateValidation, coerceNumber } from '../../../validation';

export const EbpCaseSupportAuthorizationActionSchema = z.object({
  type: z.enum(EbpCaseSupportAuthorizationActionType),
  by: z.string().nullish(),
  endDate: z
    .object({ old: dateValidation().optional(), new: dateValidation() })
    .optional(),
  maxAppointments: z
    .object({
      old: coerceNumber(z.number()),
      new: coerceNumber(z.number()),
    })
    .optional(),
  notes: z.string().optional(),
  link: z.string().optional(),
  createdAt: dateValidation(),
});

export type EbpCaseSupportAuthorizationAction = z.infer<
  typeof EbpCaseSupportAuthorizationActionSchema
>;
